const integrationStates = Object.freeze({
  CONNECT: 'connect',
  WAITING_FOR_APPROVAL: 'WaitingForApproval',
  CONFIGURE: 'configure',
  ACTIVE: 'active',
})

export default integrationStates
export const { CONNECT, WAITING_FOR_APPROVAL, CONFIGURE, ACTIVE } = integrationStates
export const AUTO_RESOLVE = 'AutoResolve by NoiseAware'
